import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import MyDatePickerField from "../forms/MyDatePickerField";
import Dayjs from "dayjs";

import MyTextField from "../forms/MyTextField";
import MySelectField from "../forms/MySelectField";
import MyMultilineField from "../forms/MyMultilineField";
import AxiosInstance from "../Axios";
import MyMultiSelectField from "../forms/MyMultiSelectField";
import { useState, useEffect } from "react";
import { fetchVariableValues } from "../../Extractor";
import colors from "../constants/Colors";
import axios from "axios";
import Swal from "sweetalert2";

const CreateWebsiteAct = () => {
  const navigate = useNavigate();
  const project_id = localStorage.getItem("project_id");

  const defaultValues = {
    notes: "",
    type: "",
    audience: "",
    description: "",
    status: "",
    reportingPeriod: "",
    link: "",
    dateDissemination: null,
    estimation: "",
    partners: "",
  };
  const schema = yup.object({
    notes: yup.string().required("A name is required"),
    type: yup.string().required("A type is required"),
    audience: yup
      .array()
      .of(yup.string())
      .min(1, "At least one type of audience is required")
      .required("The type of audience is required"),
    description: yup.string().required("A description is required"),
    status: yup.string().required("A status is required"),
    reportingPeriod: yup.string().required("RP is required"),
    link: yup.string(),

    dateDissemination: yup.date(),
    estimation: yup
      .number()
      .typeError("Estimation must be a number")
      .required("the estimation is required"),

    /*start_date: yup.date().required('Start date is a required field'),
    end_date: yup.date().required('End date is a required field').min(yup.ref('start_date'), 'The end date cannot be before the start date'),*/
  });

  const { handleSubmit, control } = useForm({
    defaultValues: defaultValues,
    resolver: yupResolver(schema),
  });

  const [audienceOptions, setAudienceOptions] = useState([]);
  const [reportingPeriodOptions, setReportingPeriodOptions] = useState([]);
  const [typeWebsiteOptions, setTypeWebsiteOptions] = useState([]);
  const [fullPartnerData, setFullPartnerData] = useState([]);
  const [partners, setPartners] = useState([]);

  useEffect(() => {
    const getOptions = async () => {
      const { values: audienceValues } = await fetchVariableValues("Audiences");
      setAudienceOptions(audienceValues.map((v) => v.name));

      const { values: reportingPeriodValues } = await fetchVariableValues(
        "Reporting Period"
      );
      setReportingPeriodOptions(reportingPeriodValues.map((v) => v.name));

      const { values: typeWebsiteValues } = await fetchVariableValues(
        "Dissemination Activities"
      );
      setTypeWebsiteOptions(typeWebsiteValues.map((v) => v.name));
    };

    getOptions();
  }, []);

  // useEffect(() => {
  //   const getAudienceOptions = async () => {
  //     const { values } = await fetchVariableValues('Audiences');
  //     setAudienceOptions(values);
  //   };

  //   const getReportingPeriodOptions = async () => {
  //     const { values } = await fetchVariableValues('Reporting Period');
  //     setReportingPeriodOptions(values);
  //   };

  //   const getTypeWebsiteOptions = async () => {
  //     const { values } = await fetchVariableValues('Type of Web Activity');
  //     setTypeWebsiteOptions(values);
  //   };

  //   getAudienceOptions();
  //   getReportingPeriodOptions();
  //   getTypeWebsiteOptions();
  // }, []);

  const submission = (data) => {
    /*const StartDate = Dayjs(data.start_date["$d"]).format("YYYY-MM-DD")
    const EndDate = Dayjs(data.end_date["$d"]).format("YYYY-MM-DD")*/
    const Date = Dayjs(data.dateDissemination).format("YYYY-MM-DD");
    console.log(data);

    const selectedPartnerIds = data.partners
      ? data.partners
          .map((partnerName) => {
            const partner = fullPartnerData.find((p) => p.name === partnerName);
            return partner ? partner.id : null;
          })
          .filter((id) => id !== null)
      : [];

    AxiosInstance.post(`projects/${project_id}/websites/`, {
      notes: data.notes,
      type: data.type,
      audiences: data.audience,
      description: data.description,
      status: data.status,
      reportingPeriod: data.reportingPeriod,
      link: data.link,
      dateDissemination: Date,
      estimation: Math.round(data.estimation / data.audience.length),
      partner_ids: selectedPartnerIds,
    })

      /** Renvoie l'utilisateur a la home page des que le submit est clické */
      .then((res) => {
        navigate(`/`);
      })
      .catch((error) => {
        if (
          error.response &&
          error.response.data &&
          error.response.data.error
        ) {
          Swal.fire({
            title: "Error",
            text: error.response.data.error,
            icon: "error",
            confirmButtonColor: colors.secondary,
          });
        } else {
          Swal.fire({
            title: "Error",
            text: "An error occurred while creating the event.",
            icon: "error",
            confirmButtonColor: colors.secondary,
          });
        }
      });
  };

  const userId = localStorage.getItem("user_id");

  useEffect(() => {
    const getPartnersInProject = async () => {
      try {
        const response = await AxiosInstance.get(
          `projects/${project_id}/get_partners/`
        );

        if (response.status === 200) {
          const userIdNumber = parseInt(userId, 10);

          /*   const filteredPartners = response.data.filter(
            (partner) => partner.pic !== userIdNumber
          ); */

          const filteredPartners = response.data;
          // Extract just the names and IDs for the dropdown
          const partnerOptions = filteredPartners.map(
            (partner) => partner.name
          );
          setPartners(partnerOptions);

          // Store the full partner objects separately if needed
          setFullPartnerData(filteredPartners);
        }
      } catch (error) {
        console.error("There was an error fetching partners!", error);
      }
    };
    getPartnersInProject();
  }, [userId]);

  const sortedReportingPeriodOptions = reportingPeriodOptions.sort((a, b) =>
    a.localeCompare(b)
  );
  return (
    <div>
      <form onSubmit={handleSubmit(submission)}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            backgroundColor: colors.secondary,
            marginBottom: "10px",
            borderTopRightRadius: 5,
            borderTopLeftRadius: 5,
          }}
        >
          <Typography sx={{ marginLeft: "20px", color: "#fff" }}>
            Add a dissemination activity
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            width: "100%",
            boxShadow: 3,
            padding: 4,
            flexDirection: "column",
            marginTop: -1,
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-around",
              marginBottom: "40px",
            }}
          >
            <MyMultilineField
              label={
                <span>
                  Name of dissemination<span style={{ color: "red" }}> *</span>
                </span>
              }
              // label="Name of dissemination"
              name="notes"
              control={control}
              width={"30%"}
            />
            <MySelectField
              label={
                <span>
                  Type of dissemination<span style={{ color: "red" }}> *</span>
                </span>
              }
              //label="Type of dissemination"
              name="type"
              control={control}
              width={"30%"}
              options={typeWebsiteOptions}
            />

            <MyMultiSelectField
              label={
                <span>
                  Type of audience<span style={{ color: "red" }}> *</span>
                </span>
              }
              //label="Type of audience"
              name="audience"
              control={control}
              width={"30%"}
              options={audienceOptions}
            />
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-around",
              marginBottom: "40px",
            }}
          >
            <MyMultilineField
              label={
                <span>
                  Short description<span style={{ color: "red" }}> *</span>
                </span>
              }
              //label="Short description"
              name="description"
              control={control}
              width={"30%"}
            />
            <MySelectField
              label={
                <span>
                  Status<span style={{ color: "red" }}> *</span>
                </span>
              }
              // label="Status"
              name="status"
              control={control}
              width={"30%"}
              options={["Cancelled", "Ongoing", "Delivered", "Postponed"]}
            />
            <MySelectField
              label={
                <span>
                  Reporting Period<span style={{ color: "red" }}> *</span>
                </span>
              }
              // label="Reporting Period"
              name="reportingPeriod"
              control={control}
              width={"30%"}
              options={sortedReportingPeriodOptions}
            />
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-around",
              marginBottom: "40px",
            }}
          >
            <MyMultilineField
              label="Link"
              name="link"
              control={control}
              width={"30%"}
            />
            <MyDatePickerField
              label={
                <span>
                  Date<span style={{ color: "red" }}> *</span>
                </span>
              }
              //label="Date"
              name="dateDissemination"
              control={control}
              width={"30%"}
            />

            <MyTextField
              label="Estimation people"
              name="estimation"
              placeholder="Reached audiences"
              control={control}
              width={"30%"}
              marginTop={15}
            />
          </Box>

          <Box sx={{ display: "flex", flexDirection: "column", marginTop: 10 }}>
            <span style={{ display: "flex", justifyContent: "flex-start" }}>
              Would you like to add partner(s) to this activity?
            </span>
            <hr />
            <br />
            <MyMultiSelectField
              label={
                <span>
                  Partners<span style={{ color: "red" }}></span>
                </span>
              }
              name="partners"
              control={control}
              width={"30%"}
              options={partners}
            />
            <br />

            {/* Alignement des boutons */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                width: "100%",
                marginTop: 2,
              }}
            >
              <Button
                variant="contained"
                type="submit"
                sx={{
                  width: "150px",
                  backgroundColor: colors.secondary,
                  marginRight: 2,
                }}
              >
                Submit
              </Button>
              <Button
                variant="contained"
                onClick={() => navigate("/")}
                sx={{ width: "150px", backgroundColor: "gray" }}
              >
                Cancel
              </Button>
            </Box>
          </Box>
        </Box>
      </form>
    </div>
  );
};

export default CreateWebsiteAct;
